module.exports = __webpack_public_path__ + "static/21-35887b5088d783a8790b3313ee035f1d.png";